module.exports = __webpack_public_path__ + "img/west-1-photo.a2fa9ad8.png";